import { css } from '@/styled-system/css';

export const shareFormContainerCX = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const shareFormTitleCX = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const socialListCX = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '0',
  listStyle: 'none',
  padding: '0',
  margin: '0',
});

export const socialItemCX = css({
  display: 'flex',
  alignItems: 'center',
  gap: '2x',
  paddingTop: '12px',
  paddingBottom: '12px',
  paddingLeft: '0',
  paddingRight: '0',
  cursor: 'pointer',
  color: 'hpxTeal500',
  fontWeight: 'bold',
  fontSize: 'md',
  background: 'none',
  border: 'none',
  width: '100%',
  textAlign: 'left',
  textDecoration: 'none',
  _hover: {
    color: 'hpxTeal600',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '4px',
  },
});

export const socialIconCX = css({
  width: '24px',
  height: '24px',
  flexShrink: 0,
});
